module.exports = __webpack_public_path__ + "img/x2.81beb46b.png";